/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `MATERIAL_QUALITY` - Material Quality
* `PACKAGING_SPECIFICATION` - Packaging Specification
 */
export type MaterialComponentCategory = typeof MaterialComponentCategory[keyof typeof MaterialComponentCategory];


export const MaterialComponentCategory = {
  MATERIAL_QUALITY: 'MATERIAL_QUALITY',
  PACKAGING_SPECIFICATION: 'PACKAGING_SPECIFICATION',
} as const;
